import {Component} from "preact";
import { appContext } from './badge2.context.js';
import { BadgeService } from './domain/badge.service.js';

/**
 * @typedef {RenderableProps} _BaseComponentProps
 * @property {function(ref: BaseComponent)} onRef use to obtain ref to a child component from parent.
 */

/**
 * Defines globally common code for our badge components, and assures consistency.
 */
export class BaseComponent extends Component {

  /** @type {_BaseComponentProps} */
  props;

  /** @type {BadgeService} */
  get badgeService() {
    return appContext.obtain(BadgeService);
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(undefined);
    }
  }

}
